import useScript from '@hooks/useScript';
import React, { useState } from 'react';

import { HubSpotFormCreateOptions } from './HubSpotFormCreateOptions';

declare global {
  interface Window {
    hbspt?: {
      forms?: {
        create: (o: HubSpotFormCreateOptions) => void;
      }
    }
  }
}

const HubSpotForm = (props : HubSpotFormCreateOptions) => {
  const { portalId, formId } = props;
  const [formLoaded, setFormLoaded] = useState(false);
  const elementId = `hubspot-form-${portalId}--${formId}`;

  useScript('//js.hsforms.net/forms/v2.js', {}, {
    onLoad: () => {
      if (window?.hbspt && !formLoaded) {
        window.hbspt.forms.create({
          portalId,
          formId,
          target: '#' + elementId
        });
        setFormLoaded(true);
      }
    }
  });

  return (<div id={elementId} />);
};

export default HubSpotForm;
